import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Col, Row, Panel, Button, Breadcrumb, ButtonToolbar, Field } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { SkyLightStateless } from 'react-skylight';
import axios from 'axios';
import ReactDOM from 'react-dom';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import { companyCodeTitle } from '../../actions/root_url';
import { USER_PRODUCTS_URL } from '../../actions/url';

const tableHeight = (window.innerHeight < 930) ? 650 : 650;

class MobileUserProducts extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      products: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      isLoading: false,
      error: '',
      selectedProduct: {},
      editModalOpen: false,
    };
    this.setEditModalVisibility = this.setEditModalVisibility.bind(this);
  }

  componentWillMount() {
    const { currentProduct } = this.props;
    // this.props.setValue('productForm', 'PackageSize', '2');
    // this.props.setDefaultOfForm("PriceType", "weight", "productForm")
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    this.getProductsById();
  }

  getProductsById() {
    const { id } = this.context.router.params;
    if (!id) {
      return;
    }
    const data = new FormData();
    data.append('pk', id);
    axios.post(
      USER_PRODUCTS_URL,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      if (response.status !== 200) {
        return;
      }
      const products = { ...this.state.products, rows: response.data };
      this.setState({ products, error: '', isLoading: false });
    })
      .catch((error) => {
        this.setState({ error, isLoading: false });
      });
  }

  setEditModalVisibility(editModalOpen = false) {
    this.setState({ editModalOpen });
  }

  editProdcut(e) {
    e.preventDefault();
    const { selectedProduct } = this.state;
    console.log('selectedProduct:  ', selectedProduct);
    this.setEditModalVisibility(true);
  }

  handleOnSubmit() {
    console.log('handleOnSubmit');
  }

  handleChange(event) {
    console.log('handleChange: ', event);
    // this.setState({ value: event.target.value });
  }

  renderTable() {
    if (this.state.isLoading && !this.state.error) return <Spinner />;
    else if (this.state.error) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.state.error)}</div>
        </ContentWrapper>
      );
    }

    // Parameters of the react-data-grid
    const getRows = () => Data.Selectors.getRows(this.state.products);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleGridSort = (sortColumn, sortDirection) => {
      const products = Object.assign({}, this.state.products, { sortColumn, sortDirection });
      this.setState({ products });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.products.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const products = { ...this.state.products, filters: newFilters };
      this.setState({ products });
    };

    // Handle the row select function
    const onRowsSelected = (rows) => {
      // const newRows = this.state.products.rows;
      // rows.map((r) => {
      //   newRows[r.rowIdx].isSelected = true;
      // });

      const newRows = getRows();
      newRows.map((r) => {
        r.isSelected = false;
      });
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = true;
      });
      const products = { ...this.state.products, rows: newRows };
      this.setState({ products, selectedProduct: rows[0].row });
    };

    const onRowsDeselected = (rows) => {
      const newRows = getRows();
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = false;
      });
      this.setState({ selectedProduct: {} });
    };

    // Column difinition
    const columns = [
      {
        key: 'Product_sku',
        name: 'SKU',
        width: 100,
        resizable: true,
        sortable: true,
        filterable: true,
      },
      {
        key: 'Product_name',
        name: 'Name',
        width: 150,
        resizable: true,
        sortable: true,
        filterable: true,
      },
      {
        key: 'Product_quantity',
        name: 'Qty',
        width: 80,
        resizable: true,
        sortable: true,
        filterable: true,
      },
      {
        key: 'Alert_quantity',
        name: 'Alert Qty',
        width: 80,
        resizable: true,
        sortable: true,
        filterable: true,
      },
      {
        key: 'History_quantity',
        name: 'History Qty',
        width: 80,
        resizable: true,
        sortable: true,
        filterable: true,
      },
    ];

    return (
      <ContentWrapper>
        <Row>
          <div id="mobileUserMessagesManagement-dataGrid1">
            <ReactDataGrid
              rowKey="Product_id"
              onGridSort={handleGridSort}
              toolbar={<Toolbar enableFilter />}
              headerRowHeight={50}
              rowHeight={25}
              onAddFilter={handleFilterChange}
              columns={columns}
              width={200}
              minHeight={tableHeight}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              enableRowSelect="single"
              rowSelection={{
                showCheckbox: true,
                onRowsSelected,
                onRowsDeselected,
                selectBy: { isSelectedKey: 'isSelected' },
              }}
            />
          </div>
        </Row>
        <Row className="total-users">
          <label>
            <Translate value="total_users" />:&nbsp;
            <span className="font-color-orange">{this.state.products.rows.length}</span>
          </label>
        </Row>
      </ContentWrapper>
    );
  }

  render() {
    const { selectedProduct } = this.state;
    return (
      //---------------
      // Begin HTML: Create New/Edit user_management
      //---------------
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="Admin" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="mobile_user_products" />
          </Breadcrumb.Item>
          <ButtonToolbar
            style={{
              zIndex: 1,
              position: 'absolute',
              top: '10px',
              right: '10px',
            }}
          />
        </Breadcrumb>
        <Grid id="settings-user-management">
          <Panel className="position-relative table-collapse-fix">
            {
              !this.state.isLoading &&
              !this.state.error &&
                <ButtonToolbar className="table-buttons">
                  <Button
                    bsStyle="success"
                    className="marginLeftStyle"
                    onClick={(event) => { this.editProdcut(event); }}
                    disabled={!this.state.selectedProduct.Product_id}
                  >
                    <em className="fa fa-pencil" /><Translate value="edit_product" />
                  </Button>
                </ButtonToolbar>
            }
            {this.renderTable()}
          </Panel>
        </Grid>
        <SkyLightStateless
          dialogStyles={{ height: '450px', width: '500px' }}
          isVisible={this.state.editModalOpen}
          onCloseClicked={this.setEditModalVisibility}
          title="Edit Product"
        >
          <form className="form-horizontal" onSubmit={this.handleSubmit} >
            <div>
              <Col>
                <div className="product-img-view">
                  <img src={selectedProduct.Product_image} alt="Upload image" className="img-thumbnail" style={{
                    height: '100px', width: '100px' }}
                  />
                </div>
                <div>
                  <div className="form-group">
                    <label className="col-xs-2"><Translate value="sku" /></label>
                    <div className="col-xs-8">
                      <input type="text" value={selectedProduct.Product_sku} onChange={this.handleChange} className="form-control" />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-xs-2"><Translate value="name" /></label>
                    <div className="col-xs-8">
                      <input type="text" value={selectedProduct.Product_name} onChange={this.handleChange} className="form-control" />
                    </div>
                  </div>
                </div>
                <div>
                  <div className="form-group">
                    <label className="col-xs-2"><Translate value="quantity" /></label>
                    <div className="col-xs-8">
                      <input type="text" value={selectedProduct.Product_quantity} onChange={this.handleChange} className="form-control" />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-xs-2">Alert Qty</label>
                    <div className="col-xs-8">
                      <input type="text" value={selectedProduct.Alert_quantity} onChange={this.handleChange} className="form-control" />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-xs-2">History Qty</label>
                    <div className="col-xs-8">
                      <input type="text" value={selectedProduct.History_quantity} onChange={this.handleChange} className="form-control" />
                    </div>
                  </div>
                </div>
              </Col>
            </div>
          </form>
          <Button
            bsStyle="success"
            onClick={() => { this.handleOnSubmit(); }}
          >
            <Translate value="save" />
          </Button>
        </SkyLightStateless>
      </ContentWrapper>
    );
  }
}

export default MobileUserProducts;



// WEBPACK FOOTER //
// ./master/jsx/components/Settings/mobileUserProducts.jsx